import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, ConfirmationComponent, Notification, NotificationService, NotificationTypeEnum, Pager, UtilHelper } from 'lib-trend-core';
import { Observable, Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
@Component({
    selector: 'notification-component',
    // templateUrl: 'notification.component.html'
    templateUrl: 'notification.v2.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationComponent extends AbstractComponent implements OnInit {

  pager: Pager<Notification> = new Pager<Notification>({ perPage: 25 });

  listObservable: Observable<Pager<Notification>>;
  private termOfSearch: Subject<string> = new Subject<string>();

  constructor(
    public injector: Injector,
    public dialog: MatDialog,
    private notificationService: NotificationService,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.searchParams = {
      company: this.getIDCurrentCompany(),
    }

    this.notificationService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams).subscribe({
      next: (pager: Pager<Notification>) => {
        this.pager = pager;
        this.setupObservableSearch();
      },
      error: (err) => this.alertService.error(err.error.message)
    })
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  setupObservableSearch() {
    this.listObservable = this.termOfSearch
      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .pipe(switchMap(term => {
        return this.notificationService.getAll(this.pager.page, this.pager.perPage, term, this.searchParams);
      }));
    this.listObservable.subscribe((pager: Pager<Notification>) => {
      this.pager = pager;
    });
  }

  search(term: string) {
    this.pager.page = 1;
    this.searchString = term;
    this.termOfSearch.next(term);
  }

  delete(notification: Notification) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        this.notificationService.delete(notification._id).subscribe({
          next: () => {
            this.getList();
            this.alertService.success();
          },
          error: err => this.alertService.error(err.error.message)
        })
      }
    });
  }

  notify(notification: Notification) {
    if (!!notification.attendance) {
      this.router.navigate(['/attendance/panel'], { queryParams: { id: notification.attendance._id, status: notification.attendance.status } });
    } else if (notification.type === NotificationTypeEnum.IMPORTATION) {
      this.router.navigate(['/report/view-importation']);
    } else if (notification.type === NotificationTypeEnum.INTEGRATION) {
      // AI integration taken out of rotation (no credits / bad credentials / unknown model):
      // the OpenAI integrations list shows the reason and the "reactivate" action.
      this.router.navigate(['/agents/openai']);
    } else if (notification.type === NotificationTypeEnum.CREDIT) {
      // Typed wallets: AI keeps pointing at the agents screen (its balance still
      // lives there), everything else goes to its own Credits page
      // (SPEC-2026-08-typed-wallets RF-22). `walletType` is absent on
      // notifications created before typed wallets, which correctly falls back.
      const walletType = (notification as any)?.walletType;
      if (walletType && walletType !== 'AI') {
        this.router.navigate(['/wallet', walletType]);
      } else {
        this.router.navigate(['/agents/trendgpt']);
      }
    }
  }

  removeHtml(text: string): string {
    return UtilHelper.removeHtmlTags(text);
  }

}
